import { ModuleNavItem } from '../../contexts/ModuleNavContext';

export interface GroupedItem {
  /** The group label key, or null for ungrouped items. */
  groupKey: string | null;
  items: ModuleNavItem[];
}
export type GroupedItems = GroupedItem[];

export function groupItemsByGroup(items: ModuleNavItem[] | null): GroupedItems {
  if (!items || items.length === 0) return [];
  const buckets: GroupedItem[] = [];
  const indexByKey = new Map<string | null, number>();

  for (const item of items) {
    const key = item.group ?? null;
    let idx = indexByKey.get(key);
    if (idx === undefined) {
      idx = buckets.length;
      buckets.push({ groupKey: key, items: [] });
      indexByKey.set(key, idx);
    }
    buckets[idx].items.push(item);
  }
  return buckets;
}
